const ARHI = [{
  link: '/docs/privacy-policy',
  text: 'Privacy Policy',
  iconType: 'PDF'
}];
const NIBP2PWEB = [{
  link: 'https://www.nib.com.au/docs/privacy-policy ',
  text: 'Privacy Policy',
  iconType: 'PDF'
}];
const CORPORATE = [{
  link: 'https://www.nib.com.au/docs/privacy-policy ',
  text: 'Privacy Policy',
  iconType: 'PDF'
}];
const IWHI = [{
  link: 'https://www.nib.com.au/docs/privacy-policy',
  text: 'Privacy Policy',
  iconType: 'PDF'
}];
const IMAN = [{
  link: 'https://www.austhealth.com/privacy-policy',
  text: 'Privacy Policy',
  iconType: 'PDF'
}];
const APIA = [{
  link: 'https://www.apia.com.au/content/dam/suncorp/apia/documents/privacy/apia-health-privacy-statement.pdf',
  text: 'Apia Privacy Policy',
  iconType: 'PDF'
}, {
  link: 'https://www.nib.com.au/docs/privacy-policy',
  text: 'nib Privacy Policy',
  iconType: 'PDF'
}];
const ING = [{
  link: 'https://www.ing.com.au/privacy.html',
  text: 'ING Privacy Policy',
  iconType: 'URL'
}, {
  link: 'https://www.nib.com.au/docs/privacy-policy',
  text: 'nib Privacy Policy',
  iconType: 'PDF'
}, {
  link: 'https://www.ing.com.au/pdf/Insurance/CustomerEligibilityAndNameScreening_Health_Insurance.pdf',
  text: 'ING Customer Eligibility and Name-Screening',
  iconType: 'PDF'
}];
const SUNCORP = [{
  link: 'https://www.suncorp.com.au/about-us/legal/privacy.html',
  text: 'Suncorp Privacy Policy',
  iconType: 'URL'
}, {
  link: 'https://www.nib.com.au/docs/privacy-policy',
  text: 'nib Privacy Policy',
  iconType: 'PDF'
}];
const AAMI = [{
  link: 'https://www.aami.com.au/privacy.html',
  text: 'AAMI Privacy Policy',
  iconType: 'URL'
}, {
  link: 'https://www.nib.com.au/docs/privacy-policy',
  text: 'nib Privacy Policy',
  iconType: 'PDF'
}];
const PRICELINE = [{
  link: 'https://www.priceline.com.au/privacy-policy',
  text: 'Priceline Privacy Policy',
  iconType: 'URL'
}, {
  link: 'https://www.nib.com.au/docs/privacy-policy',
  text: 'nib Privacy Policy',
  iconType: 'PDF'
}];
const SENIORS = [{
  link: 'https://www.seniors.com.au/privacy-collection-notice',
  text: 'Australian Seniors Privacy Policy',
  iconType: 'URL'
}, {
  link: 'https://www.nib.com.au/docs/privacy-policy',
  text: 'nib Privacy Policy',
  iconType: 'PDF'
}];
const REAL = [{
  link: 'https://www.realinsurance.com.au/privacy-collection',
  text: 'Real Insurance Privacy Policy',
  iconType: 'URL'
}, {
  link: 'https://www.nib.com.au/docs/privacy-policy',
  text: 'nib Privacy Policy',
  iconType: 'PDF'
}];
const GUHEALTH = [{
  link: 'https://www.guhealth.com.au/docs/gu-health-privacy-policy ',
  text: 'GU Privacy Policy',
  iconType: 'PDF'
}];
const PRIVACY_POLICY_LINKS = {
  ARHI,
  APIA,
  IWHI,
  IMAN,
  ING,
  SUNCORP,
  AAMI,
  PRICELINE,
  SENIORS,
  REAL,
  NIBP2PWEB,
  CORPORATE,
  GUHEALTH
};
export default PRIVACY_POLICY_LINKS;